<template>
  <div class="content">
    <van-form
      @submit="submitForm"
      @failed="validateFailed"
      ref="formRef"
      validate-trigger="onSubmit"
      :show-error-message="false"
      :validate-first="true"
    >
      <div>
        <van-divider
          content-position="left"
          :style="{ color: 'black', borderColor: 'black' }"
        >
          最近的工作经历
        </van-divider>
        <van-field
          name="isHasWorkExperience"
          :rules="formRules.isHasWorkExperience"
          label="是否有工作经验"
          required
        >
          <template #input>
            <van-radio-group
              v-model="formInfo['isHasWorkExperience']"
              direction="horizontal"
            >
              <van-radio name="0">否</van-radio>
              <van-radio name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div v-if="formInfo['isHasWorkExperience'] === '1'">
          <van-field
            v-model="formInfo['latelyWorkStartEndTime']"
            is-link
            readonly
            required
            label="最近的工作起止时间"
            placeholder="请选择"
            @click="
              datePicker.open(
                'latelyWorkStartTime',
                'latelyWorkEndTime',
                'latelyWorkStartEndTime'
              )
            "
          />
          <van-field
            v-model="formInfo['latelyCompanyName']"
            :rules="formRules.latelyCompanyName"
            label="最近的工作单位名称"
            placeholder="填写工作单位名称"
            required
          ></van-field>
          <van-field
            name="isHasLeftCertificate"
            label="是否能提供离职证明"
            :rules="formRules.isHasLeftCertificate"
            required
          >
            <template #input>
              <van-radio-group
                v-model="formInfo['isHasLeftCertificate']"
                direction="horizontal"
              >
                <van-radio
                  v-for="(value, key) in radioMap.isHasLeftCertificate"
                  :name="key"
                  :key='key'
                >
                  {{ value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-if="formInfo['isHasLeftCertificate'] === '0'"
            name="noLeftCertificate"
            :rules="formRules.noLeftCertificate"
            label="无法提供离职证明的原因"
            required
          >
            <template #input>
              <van-radio-group
                v-model="formInfo['noLeftCertificate']"
                direction="horizontal"
              >
                <van-radio
                  v-for="(value, key) in radioMap.noLeftCertificate"
                  :name="key"
                  :key='key'
                >
                  {{ value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>

        <van-field
          type="textarea"
          v-if="
            formInfo['noLeftCertificate'] === '2'
          "
          v-model="formInfo['noLeftCertificateOther']"
          :rules="formRules.noLeftCertificateOther"
          label="原因"
          label-align="top"
          required
          placeholder="填写原因"
        />
      </div>

      <div>
        <van-divider
          content-position="left"
          :style="{ color: 'black', borderColor: 'black' }"
        >
          <template #default>职业史及职业危害接触史调査表</template>
        </van-divider>
        <van-field
          name="isHasHistoricalWork"
          :rules="formRules.isHasHistoricalWork"
          label="是否有职业史及职业危害接触史"
          required
        >
          <template #input>
            <van-radio-group
              v-model="formInfo['isHasHistoricalWork']"
              direction="horizontal"
            >
              <van-radio name="0">否</van-radio>
              <van-radio name="1">是</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div v-for="i in workCount" :key="i">
          <van-cell :title="`工作经历（${i}）`">
            <!-- 使用 right-icon 插槽来自定义右侧图标 -->
            <template #right-icon>
              <van-icon
                v-if="workCount === i && workCount < maxWorkCount"
                name="add-o"
                color="blue"
                size="30"
                @click="workCount++"
              />
              <van-icon
                v-if="workCount === i && i > 1"
                name="close"
                color="red"
                size="30"
                @click="deleteWork(i)"
              />
            </template>
          </van-cell>
          <van-field
            v-model="formInfo['workStartEndTime' + i]"
            is-link
            readonly
            required
            label="工作起止时间"
            placeholder="请选择"
            @click="
              datePicker.open(
                'workStartTime' + i,
                'workEndTime' + i,
                'workStartEndTime' + i
              )
            "
          />
          <van-field
            v-model="formInfo['companyName' + i]"
            label="工作单位名称"
            placeholder="填写工作单位名称"
            required
          ></van-field>
          <van-field
            v-model="formInfo['jobName' + i]"
            label="工种/岗位名称"
            placeholder="填写工种/岗位名称"
            required
          ></van-field>
          <van-field
            type="number"
            v-model="formInfo['workHour' + i]"
            label="工作时间"
            placeholder="填写工作时间"
            required
          >
            <template #extra>
              <van-tag plain type="primary">小时/天</van-tag>
            </template>
          </van-field>
          <van-field
            :name="'protectiveMeasures' + i"
            label="工作中使用的防护措施"
            required
          >
            <template #input>
              <van-radio-group
                v-model="formInfo['protectiveMeasures' + i]"
                direction="horizontal"
              >
                <van-radio
                  v-for="(value, key) in radioMap.protectiveMeasures"
                  :name="key"
                  :key='key'
                >
                  {{ value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            :name="'protectiveEquipment' + i"
            label="工作中使用的防护用品"
            required
          >
            <template #input>
              <van-radio-group
                v-model="formInfo['protectiveEquipment' + i]"
                direction="horizontal"
              >
                <van-radio
                  v-for="(value, key) in radioMap.protectiveEquipment"
                  :name="key"
                  :key='key'
                >
                  {{ value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            :name="'occupationalHazard' + i"
            label="工作中接触的职业危害因素"
            required
          >
            <template #input>
              <van-radio-group
                v-model="formInfo['occupationalHazard' + i]"
                direction="horizontal"
              >
                <van-radio
                  v-for="(value, key) in radioMap.occupationalHazard"
                  :name="key"
                  :key='key'
                >
                  {{ value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
      </div>

      <div class="opt">
        <van-button
          class="btn"
          block
          type="primary"
          color="linear-gradient(to right, #4cbafe, #4473f7)"
          round
          native-type="submit"
        >
          保存
        </van-button>
        <van-button
          class="btn"
          type="default"
          round
          block
          native-type="button"
          @click="cancel"
        >
          取消
        </van-button>
      </div>
    </van-form>

    <StartEndDatePicker
      ref="startEndDatePickerRef"
      @confirm="confirmDatePicker"
    />
  </div>
</template>

<script>
import StartEndDatePicker from '../../components/StartEndDatePicker/index.vue'
import { getTempData, saveTempData } from '../../api/empSystem/position'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'empTempData3',
  components: {
    StartEndDatePicker
  },
  data() {
    return {
      contractId: "",
      formInfo: {},
      radioMap: {
        isHasLeftCertificate: {0: "否", 1: "是"},
        noLeftCertificate: {1: "原件不慎丢失", 2: "其他"},
        protectiveMeasures: {1: "抽风装置", 2: "除尘装置", 3: "净化装置", 4: "无"},
        protectiveEquipment: {1: "耳塞", 2: "口罩", 3: "防毒面具", 4: "其他", 5: "无"},
        occupationalHazard: {1: "噪音", 2: "粉尘", 3: "化学因素", 4: "其他", "5": "无"},
        isPhysicalExamination: {0: "否", 1: "是"},
      },
      formRules: {
        isHasWorkExperience: [{ required: true, message: '是否有工作经验不能为空' }],
        latelyCompanyName: [{ required: true, message: '最近工作单位名称不能为空' }],
        isHasLeftCertificate: [{ required: true, message: '是否能提供离职证明不能为空' }],
        noLeftCertificate: [{ required: true, message: '无法提供离职证明的原因不能为空' }],
        noLeftCertificateOther: [{ required: true, message: '原因不能为空' }],
        isHasHistoricalWork: [{ required: true, message: '是否有职业史及职业危害接触史不能为空' }],
      },
      workCount: 0,
      maxWorkCount: 3,
      datePicker: {
        modelField: '',
        startTimeField: '',
        endTimeField: '',
      }
    }
  },
  methods: {
    deleteWork(i) {
      this.formInfo['workStartEndTime' + i] = ''
      this.formInfo['workStartTime' + i] = ''
      this.formInfo['workEndTime' + i] = ''
      this.formInfo['companyName' + i] = ''
      this.formInfo['jobName' + i] = ''
      this.formInfo['workHour' + i] = ''
      this.formInfo['protectiveMeasures' + i] = ''
      this.formInfo['protectiveEquipment' + i] = ''
      this.formInfo['occupationalHazard' + i] = ''

      this.workCount--
    },
    openDatePicker(startTimeField, endTimeField, modelField) {
      this.datePicker.startTimeField = startTimeField
      this.datePicker.endTimeField = endTimeField
      this.datePicker.modelField = modelField
      this.$refs.startEndDatePickerRef.open()
    },
    confirmDatePicker(startTime, endTime) {
      this.formInfo[this.datePicker.startTimeField] = startTime
      this.formInfo[this.datePicker.endTimeField] = endTime
      this.formInfo[this.datePicker.modelField] = startTime + '到' + endTime
    },
    validateFailed({ errors }) {
      this.$notify({ type: 'danger', message: errors[0].message, duration: 3000 })
    },
    async submitForm() {
      if (Number(this.formInfo['isHasWorkExperience']) === 1) {
        if (!this.formInfo['latelyWorkStartTime'] || !this.formInfo['latelyWorkEndTime']) {
          this.$notify({
            type: 'danger',
            message: '最近工作起止时间不能为空',
            duration: 3000,
          })
          return
        }
      } else {
        this.formInfo['noLeftCertificate'] = "2"
        this.formInfo['noLeftCertificateOther'] = "无"
        this.formInfo['latelyWorkStartTime'] = "无"
        this.formInfo['latelyWorkEndTime'] = "无"
        this.formInfo['latelyCompanyName'] = "无"
      }

      for (let i = 1; i <= this.maxWorkCount; i++) {
        if (i <= this.workCount) {
          if (!this.formInfo['workStartEndTime' + i] || !this.formInfo['workStartTime' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作时间不能为空`,
              duration: 3000,
            })
            return
          }

          if (!this.formInfo['companyName' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作单位名称不能为空`,
              duration: 3000,
            })
            return
          }

          if (!this.formInfo['jobName' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作岗位名称不能为空`,
              duration: 3000,
            })
            return
          }

          if (!this.formInfo['workHour' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作时长不能为空`,
              duration: 3000,
            })
            return
          }

          if (!this.formInfo['protectiveMeasures' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作中使用的防护措施不能为空`,
              duration: 3000,
            })
          }

          if (!this.formInfo['protectiveEquipment' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作中使用的防护用品不能为空`,
              duration: 3000,
            })
          }

          if (!this.formInfo['occupationalHazard' + i]) {
            this.$notify({
              type: 'danger',
              message: `工作经历（${i}）工作中接触的职业危害因素不能为空`,
              duration: 3000,
            })
          }
        }

        if (!this.formInfo["workStartTime" + i]) {
          this.formInfo["workStartTime" + i] = "/"
        }

        if (!this.formInfo["workEndTime" + i]) {
          this.formInfo["workEndTime" + i] = "/"
        }

        if (!this.formInfo["companyName" + i]) {
          this.formInfo["companyName" + i] = "/"
        }

        if (!this.formInfo["jobName" + i]) {
          this.formInfo["jobName" + i] = "/"
        }

        if (!this.formInfo["workHour" + i]) {
          this.formInfo["workHour" + i] = "/"
        }

        if (!this.formInfo["protectiveMeasures" + i]) {
          this.formInfo["protectiveMeasures" + i] = "4"
        }

        if (!this.formInfo["protectiveEquipment" + i]) {
          this.formInfo["protectiveEquipment" + i] = "5"
        }

        if (!this.formInfo["occupationalHazard" + i]) {
          this.formInfo["occupationalHazard" + i] = "5"
        }

        this.formInfo['isPhysicalExamination' + i] = 0
      }

      await saveTempData({
        contractId: this.contractId,
        form: this.formInfo,
        radio: this.radioMap,
      })

      this.$toast.success({
        message: '保存成功',
        duration: 1000,
        onClose: () => {
          if (this.isEdit) {
            this.$router.push({
              path: '/myProfile',
              query: {
                returnUrl: `/contractDetail?contractId=${this.contractId}`,
              },
            })
            return
          }

          this.$router.push({
            path: '/contractDetail',
            query: {
              contractId: this.contractId,
            },
          })
        },
      })
    },
    cancel() {
      if (this.isEdit) {
        this.$router.push({
          path: '/contractDetail',
          query: {
            contractId: this.contractId,
          },
        })
        return
      }

      this.$router.push({
        path: '/myContract',
      })
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isEdit() {
      return this.$route.query.isEdit === 'edit'
    }
  },
  watch: {
    'formInfo.noLeftCertificate': {
      handler() {
        this.$set(this.formInfo, 'noLeftCertificateOther', '')
      }
    },
    'formInfo.isHasWorkExperience': {
      handler() {
        this.$set(this.formInfo, 'latelyCompanyName', '')
        this.$set(this.formInfo, 'latelyWorkStartTime', '')
        this.$set(this.formInfo, 'latelyWorkEndTime', '')
        this.$set(this.formInfo, 'isHasLeftCertificate', '')
        this.$set(this.formInfo, 'noLeftCertificate', '')
        this.$set(this.formInfo, 'noLeftCertificateOther', '')
      }
    },
    'formInfo.isHasHistoricalWork': {
      handler(newVal) {
        if (newVal === '1') {
          this.workCount = 1
        } else {
          for (let i = 1; i <= this.workCount; i++) {
            this.deleteWork(i)
          }
        }
      }
    }
  },
  created() {
    this.contractId =  this.$route.query.contractId

    const empWorkInfo = this.userInfo.empWorkInfo
    this.formInfo.joinedTime = moment(empWorkInfo.joinedTime).format('YYYY-MM-DD')

    this.formInfo.age = moment().diff(moment(this.userInfo['birthday']), 'years')

    for (let i = 1; i <= this.maxWorkCount; i++) {
      this.radioMap['protectiveMeasures' + i] = this.radioMap['protectiveMeasures']
      this.radioMap['protectiveEquipment' + i] = this.radioMap['protectiveEquipment']
      this.radioMap['occupationalHazard' + i] = this.radioMap['occupationalHazard']
      this.radioMap['isPhysicalExamination' + i] = this.radioMap['isPhysicalExamination']
    }

    if (this.isEdit) {
      getTempData({ contractId: this.contractId }).then((res) => {
        this.formInfo = JSON.parse(res.data.data)

        for (let i = 1; i <= this.maxWorkCount; i++) {
          if (this.formInfo['companyName' + i]) {
            this.workCount++
          }
        }
      })
    }
  },
}
</script>


<style scoped>
.content {
  padding: 0 1em;

  .opt {
    .btn {
      margin: 10px auto;
      width: 500px;
      height: 88px;
    }
  }
}
</style>
